import { SearchData } from './search-data.class';

export class ColumnData {
    data?: string | undefined;
    name?: string | undefined;
    searchable?: boolean;
    orderable?: boolean;
    search?: SearchData;
}
